<div *ngIf="!hidden() && pageHeader.title" class="page-header space-btw">
  <div class="page-header-title d-flex">
    @if (!(pageHeader.headerBreadcrumbManager?.nodes$ | async)?.length) {
      <h1 class="m-0 align-self-center d-flex align-items-center text-body-large">
        @if (pageHeader.icon) {
          @if (pageHeader.iconBackCommands) {
            <button mat-icon-button class="back-button" (click)="onIconClick()">
              <mat-icon>{{ pageHeader.icon }}</mat-icon>
            </button>
          } @else {
            <mat-icon class="d-flex align-items-center">{{ pageHeader.icon }}</mat-icon>
          }
        }
        <ng-template [ngIf]="pageHeader.title">{{ pageHeader.title }}</ng-template>
        <ng-template [ngIf]="pageHeader.subtitle">
          <span class="subtitle">
            {{ pageHeader.subtitle }}
          </span>
        </ng-template>
      </h1>
    }
    @if (pageHeader.headerBreadcrumbManager) {
      <scw-header-breadcrumb [manager]="pageHeader.headerBreadcrumbManager"></scw-header-breadcrumb>
    }
  </div>
  <div class="left-items">
    @if (pageHeader.showSlideshowController && pageHeader.countdownManager) {
      <app-slideshow-header-controller
        [countdownManager]="pageHeader.countdownManager"
      ></app-slideshow-header-controller>
    }

    @if (isScreenLockRunning()) {
      <button
        type="button"
        mat-mini-fab
        [matTooltip]="(isScreenLocked() ? 'general.screenLock.tapToUnlock' : 'general.screenLock.lockNow') | translate"
        (click)="onLockScreen()"
      >
        <mat-icon>{{ isScreenLocked() ? 'lock' : 'lock_open' }}</mat-icon>
      </button>
    }

    @if (pageHeader.advancedFilterManager) {
      <button
        [class]="pageHeader.advancedFilterManager.isFilterCardVisible ? 'blue-color' : ''"
        type="button"
        mat-mini-fab
        (click)="onChangeFilterCardDisplay()"
      >
        <mat-icon>filter_alt</mat-icon>
      </button>
    }

    @if (pageHeader.countdownManager && (pageHeader.countdownManager.isHiddenAndSuspended | async) === false) {
      <scw-countdown [manager]="pageHeader.countdownManager"></scw-countdown>
    }

    @if (pageHeader.pageViewAndEditModeSwitchManager && !pageHeader.pageViewAndEditModeSwitchManager.isLockedInView()) {
      <page-view-and-edit-mode-switch
        [manager]="pageHeader.pageViewAndEditModeSwitchManager"
      ></page-view-and-edit-mode-switch>
    }

    @if (pageHeader.headerButtonManager && !pageHeader.headerButtonManager.isHiddenAndSuspended) {
      <header-button [manager]="pageHeader.headerButtonManager"></header-button>
    }
  </div>
</div>

@if (pageHeader.advancedFilterManager) {
  <div [class]="!pageHeader.advancedFilterManager.isFilterCardVisible ? 'd-none' : ''">
    <app-advanced-filter [manager]="pageHeader.advancedFilterManager"></app-advanced-filter>
  </div>
}
